/** Alarm topics the summary model annotates in a call (see prompts/summary.md). */
export const FLAG_TYPES = [
  'fall',
  'chest_pain',
  'breathing',
  'sudden_weakness',
  'confusion',
  'asked_for_help',
  'scam_contact',
] as const;

export type FlagType = (typeof FLAG_TYPES)[number];

/**
 * Flags that always mean "tell the family now". `scam_contact` is deliberately absent:
 * how loud a scam call should be is a product decision (gray zone, see alert-rules.ts).
 */
export const HARD_FLAGS: ReadonlySet<FlagType> = new Set<FlagType>([
  'fall',
  'chest_pain',
  'breathing',
  'sudden_weakness',
  'confusion',
  'asked_for_help',
]);

export const isHardFlag = (flag: FlagType): boolean => HARD_FLAGS.has(flag);
